import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, UnpopularProductsComponent } from '../../../../generated/graphql';
import ProductsView from './ProductsView';

const UnpopularProductsList = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();

    return (
        <UnpopularProductsComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={331} />}
        >
            {({ data: { unpopularProducts } }) => (
                <ProductsView
                    itemsPerRow={3}
                    title={t('Unpopular products')}
                    products={unpopularProducts}
                />
            )}
        </UnpopularProductsComponent>
    );
};
export default UnpopularProductsList;